export default __webpack_public_path__ + "static/media/how-it-works-2.95e1d99f.png";